import styled from "styled-components";
import {
  NewModal,
  NewDivider,
  NewTypography,
  NewButton,
  NewBox,
} from "@bca/ui-library";
import theme from "../../styles/theme";

export const StyledModal = styled(NewModal)``;

export const StyledText = styled(NewTypography)`
  text-align: center;
  font-style: normal;
  font-weight: 700;
`;

export const StyledTitle = styled(StyledText)`
  font-size: ${(props) => (props.isMobile ? "24px" : "32px")};
  line-height: ${(props) => (props.isMobile ? "28px" : "40px")};
  color: ${theme.color.modalText};
  margin-bottom: ${(props) => (props.isMobile ? "2.2rem" : "5.5rem")};
`;

export const StyledNewDivider = styled(NewDivider)``;

export const StyledBodyContainer = styled(NewBox)`
  display: flex;
  flex-direction: column;
  margin: ${(props) => (props.isMobile ? "2.2rem 0" : "3rem 0;")};
  max-height: ${(props) => (props.isMobile ? "20rem" : null)};
`;

export const StyledUl = styled.ul`
  row-gap: 5rem;
  margin: 0;
`;

export const StyledLi = styled.li`
  &:not(:last-child) {
    margin-bottom: 0.7rem;
  }
`;

export const StyledBodyText = styled(StyledText)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.color.modalText};
  vertical-align: text-top;
  text-align: left;
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  column-gap: 1rem;
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
  margin-top: 2.875rem;
`;

export const StyledButton = styled(NewButton)`
  width: 6.9rem;
`;
